module.exports = __webpack_public_path__ + "media/src/website/images/locations/muehldorf/muehldorf_01-87fc74fd1cee7df510bc239b9a6f670a.jpg";